import httpInstance from "../httpInstance";

export const getTime = async (jwtToken: string) => {
  let res: any;
  const endpoint = `time`;

  const config = {
    headers: {
      Authorization: `${jwtToken}`,
    },
  };

  await httpInstance.get(endpoint, config)
    .then((data) => {
      res = data;
    })
    .catch((error) => {
      res = error.response;
    });

  return res;
};
